import store from '@/store';

export async function authorize(routePath, permission) {
	let userMenus = store.getters['profile/profileData'];
	if (!userMenus || !userMenus.roles || userMenus.roles.length === 0) {
		try {
			if (localStorage.getItem('ugems-accessToken')) {
				await store.dispatch('profile/getProfile');
				userMenus = store.getters['profile/profileData'];
			}
		} catch (error) {
			console.error('Failed to fetch user profile data for authorization:', error);
			return false;
		}
	}

	const hasPermission = !!(
		userMenus &&
		userMenus.roles &&
		userMenus.roles.length > 0 &&
		userMenus.roles[0].menus?.find((menu) => menu.link == routePath)?.role_menus?.authorization?.includes(permission)
	);
	console.log(`Authorization for path '${routePath}' with permission '${permission}': ${hasPermission}`);
	return hasPermission;
}
